import { ComponentPropsWithoutRef, Ref, FC } from 'react'
import { Slider as RadixSlider } from 'radix-ui'

import { mtc } from '@/styles'
import { rootStyles, trackStyles, rangeStyles, thumbStyles } from './styles'

export type SliderProps = ComponentPropsWithoutRef<typeof RadixSlider.Root> & {
  ref?: Ref<HTMLDivElement>
}

export const Slider: FC<SliderProps> = ({ className, ref, ...props }) => (
  <RadixSlider.Root
    ref={ref}
    className={mtc(rootStyles(), className)}
    {...props}
  >
    <RadixSlider.Track className={trackStyles()}>
      <RadixSlider.Range className={rangeStyles()} />
    </RadixSlider.Track>
    <RadixSlider.Thumb className={thumbStyles()} />
    <RadixSlider.Thumb className={thumbStyles()} />
  </RadixSlider.Root>
)

Slider.displayName = 'Slider'
